import React, { useState, useEffect, MutableRefObject } from "react";
import { ModalBody, Modal, ModalHeader, Button, Section, ButtonsWrapper } from "mta-rkvr-styles";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { AuthResponseBody, get } from "./api/fetch";
import { toLocaleHMin } from "./util/conversionUtils";

const SessionTimeoutModal: React.FC<{
  isLoggedIn: MutableRefObject<boolean>;
  trackRef: MutableRefObject<number>;
  logOut: Function;
}> = ({ isLoggedIn, trackRef, logOut }) => {
  const { t } = useTranslation();
  const tBase = "timeout.";

  const CHECK_FREQUENCY = 1 * 60000; // Check every 1 minute
  const WARN_BEFORE = 5 * 60000;
  const cookies = new Cookies();

  useEffect(() => {
    if (isLoggedIn.current == true) {
      const l = trackRef.current;
      //Start timeout checker
      checkSession(l); //First call might want to ignore checking track keeper
      // The track keeper is used to clear old recursive timeouts
    }
  }, [trackRef.current, isLoggedIn.current]);

  function continueCall() {
    get<AuthResponseBody>({ endPoint: "authInfo" }).then((res) => {
      if (res.ok) {
        setDisplayWarning(false);
      } else {
        doLogout();
      }
    });
  }

  function checkSession(trackNo: number) {
    const lx = trackRef.current;
    if (trackNo != lx || !isLoggedIn.current) {
      return;
    }

    const l = cookies.get("expiryTime");
    if (l == undefined) {
      // cookie missing - check again after CHECK_FREQUENCY
      setTimeout(checkSession, CHECK_FREQUENCY, trackNo);
      return;
    }

    const sessionExpiry = Math.abs(cookies.get("expiryTime"));
    console.log("session expiry " + sessionExpiry);
    console.log("session will expiry at " + getTimeoutReadable());

    const localTime = new Date().getTime();
    const curtime = localTime;
    const warnTime = Number(curtime) + Number(WARN_BEFORE);

    //console.log(`Time left until warning: ${sessionExpiry - warnTime}ms`);
    if (curtime > sessionExpiry) {
      // Session expired - LOGOUT
      doLogout();
      return;
    }

    if (warnTime > sessionExpiry && !displayWarning) {
      // Session about to expire - Warn
      setDisplayWarning(true);
    }

    const timeToWarn = sessionExpiry - warnTime;
    const timeUntilNextCheck = !displayWarning && timeToWarn > 0 ? timeToWarn : CHECK_FREQUENCY;
    console.log(`Scheduling next check to after: ${timeUntilNextCheck}ms`);
    setTimeout(checkSession, timeUntilNextCheck, trackNo);
  }

  function doLogout() {
    if (isLoggedIn) {
      logOut();
    }
    setDisplayWarning(false);
  }

  function getTimeLeftInMinutes() {
    const sessionExpiry = Math.abs(cookies.get("expiryTime"));
    const localTime = new Date().getTime();
    const calcc = sessionExpiry - localTime; // in millis

    return calcc != undefined ? Math.round(calcc / 60000) : "-";
  }

  function getTimeoutReadable() {
    const sessionExpiry = Math.abs(cookies.get("expiryTime"));
    return sessionExpiry ? toLocaleHMin(sessionExpiry) : "--";
  }

  const [displayWarning, setDisplayWarning] = useState(false);

  function renderContent() {
    return (
      <Section hideTitle>
        <p>{displayWarning ? t(`${tBase}timeoutAt`, { time: getTimeoutReadable() }) : ""}</p>
        <ButtonsWrapper>
          <Button label={t(`${tBase}continue`)} onClick={continueCall} />
          <Button label={t(`${tBase}logout`)} onClick={doLogout} />
        </ButtonsWrapper>
      </Section>
    );
  }

  return (
    <div>
      <Modal isOpen={displayWarning} toggle={undefined} size="sm">
        <ModalHeader>{t(`${tBase}title`, { timeLeft: displayWarning ? getTimeLeftInMinutes() : "" })}</ModalHeader>
        <ModalBody>{renderContent()}</ModalBody>
      </Modal>
    </div>
  );
};

export default SessionTimeoutModal;
